// @flow

import { graphql } from 'react-relay';
import createRelayMutation from 'shared/gql/createRelayMutation';

const mutation = graphql`
  mutation PickShipmentItemsMutation($input: PickShipmentItemsInput!) {
    pickShipmentItems(input: $input) {
      shipmentEdge {
        node {
          id
          shipmentNumber
          status
          actualShipDate
          order {
            id
            orderNumber
            status
          }
          customer {
            id
            name
          }
          items(first: 1000) {
            edges {
              node {
                id
                quantity
                pickedQuantity
                fullyPicked
                item {
                  id
                  name
                  itemNumber
                }
                picks {
                  id
                  quantity
                  pickedAt
                  lot {
                    id
                    lotNumber
                  }
                }
              }
            }
          }
          updatedAt
        }
      }
    }
  }
`;

export default {
  commit: createRelayMutation.bind(null, mutation),
};
